export default __webpack_public_path__ + "static/media/info_btn_icon2.5a25cd71.svg";